
const reasons = [
  {
    icon: 'ri-eye-line',
    title: 'You Deserve to See the Dings.',
    description:
      'Stock photos are lies. Every dealer uses them. We film the actual car — including the scuff on the bumper and the wear on the driver\'s seat. If it\'s there, it\'s on camera.',
  },
  {
    icon: 'ri-map-pin-line',
    title: 'Most Buyers Aren\'t Local.',
    description:
      'A huge chunk of our customers drive 2–4 hours to pick up a car. We film everything so you can make a confident decision before you make that trip — not after.',
  },
  {
    icon: 'ri-shake-hands-line',
    title: 'No Surprises at Pickup.',
    description:
      'When you arrive, the car should look exactly like the video. If it doesn\'t, something went wrong on our end — and that\'s on us to fix. The video is our promise.',
  },
  {
    icon: 'ri-price-tag-3-line',
    title: 'Honest Pricing Needs Honest Footage.',
    description:
      'We price cars based on actual condition, not aspirational condition. The video is how we prove it. You\'ll see why it\'s priced the way it is — not just take our word for it.',
  },
];

export default function WhyWeFilmEverything() {
  return (
    <section className="py-20 bg-[#1C2B1E] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left: Headline + Intro */}
          <div>
            <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2 mb-6">
              <i className="ri-vidicon-line text-[#E8B84B]"></i>
              <span className="text-sm font-medium">Our No-Hiding-Anything Policy</span>
            </div>
            <h2 className="font-['Oswald'] text-4xl md:text-5xl font-bold mb-6 leading-tight">
              Why We Film{' '}
              <span className="text-[#E8B84B]">Every Single Car</span>
            </h2>
            <p className="text-lg text-white/80 mb-6 leading-relaxed">
              Most dealers hire photographers to make their cars look better than they are. 
              We grab a camera and show you exactly what you're getting — good, bad, and everything in between.
            </p>
            <p className="text-base text-white/60 leading-relaxed">
              It's not a marketing strategy. It's just the right thing to do when someone is about to spend 
              $15,000–$60,000 on something they found online.
            </p>

            <div className="mt-8 flex items-center gap-4 p-4 bg-white/5 border border-white/10 rounded-xl">
              <div className="w-12 h-12 flex items-center justify-center bg-[#E8B84B] rounded-full flex-shrink-0">
                <i className="ri-camera-line text-2xl text-[#1C2B1E]"></i>
              </div>
              <p className="text-sm text-white/70 leading-relaxed">
                <strong className="text-white">Every car gets filmed before it's listed.</strong>{' '}
                No video = not ready to sell. That's our internal rule, and we don't break it.
              </p>
            </div>
          </div>

          {/* Right: Reason Cards */}
          <div className="grid sm:grid-cols-2 gap-5">
            {reasons.map((reason, index) => (
              <div
                key={index}
                className="bg-white/5 border border-white/10 rounded-2xl p-6 hover:border-[#E8B84B]/50 hover:bg-white/8 transition-all"
              >
                <div className="w-12 h-12 flex items-center justify-center bg-[#E8B84B]/15 rounded-xl mb-4">
                  <i className={`${reason.icon} text-2xl text-[#E8B84B]`}></i>
                </div>
                <h3 className="font-['Oswald'] text-lg font-bold text-white mb-2 leading-snug">
                  {reason.title}
                </h3>
                <p className="text-sm text-white/65 leading-relaxed">{reason.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
